class BarristersSearch {
    constructor() {
        this.bsearch = document.querySelector('.bsearch');
        if (!this.bsearch) return;

        this.form = this.bsearch?.querySelector('form');
        // .label and .value
        this.select = this.bsearch?.querySelector('select');
        this.input;
        this.preview;
        this.options;

        this.isOpened = false;
        this.currentValue;
        this.currentLabel;

        this.init();
        this.events();
    }

    init() {
        const container = document.createElement('div');
        container.classList.add('bsearch-container');

        const inner = document.createElement('div');
        inner.classList.add('bsearch-inner');

        this.preview = document.createElement('div');
        this.preview.classList.add('bsearch-preview');
        this.input = document.createElement('input');
        this.input.type = 'text';
        this.input.id = 'bsearch-input';
        const label = document.createElement('label');
        label.setAttribute('for', 'bsearch-input');
        label.textContent = 'Search';
        label.classList.add('show-for-sr');

        this.optionsWrap = document.createElement('ul');

        inner.insertAdjacentElement('beforeend', this.preview);
        inner.insertAdjacentElement('beforeend', label);
        inner.insertAdjacentElement('beforeend', this.input);
        container.insertAdjacentElement('beforeend', inner);
        container.insertAdjacentElement('beforeend', this.optionsWrap);

        this.select.insertAdjacentElement('afterend', container);

        this.setOptions();
        this.renderOptions();
        this.renderPreview();
    }

    setOptions() {
        if (!this.select.options) return;

        const options = [];

        for (let option of this.select.options) {
            if (
                !option.value ||
                (this.input.value &&
                    !option.label
                        .toLowerCase()
                        .includes(this.input.value.toLowerCase()))
            )
                continue;

            options.push(option);
        }

        this.options = options;
    }

    renderPreview() {
        if (!this.preview) return;

        this.preview.textContent = this.currentLabel
            ? this.currentLabel
            : this.select.dataset.placeholder
            ? this.select.dataset.placeholder
            : '';
    }

    renderOptions() {
        if (!this.optionsWrap) return;

        this.optionsWrap.innerHTML = '';

        const icon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3M19 19H5V5H12V3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V12H19V19Z" fill="black"></path>
      </svg>`;

        if (this.options && this.options.length) {
            for (let option of this.options) {
                const a = document.createElement('a');
                a.href = option.dataset.link;
                a.textContent = option.label;
                a.insertAdjacentHTML('beforeend', icon);

                const li = document.createElement('li');
                li.dataset.value = option.value;
                li.insertAdjacentElement('beforeend', a);

                this.optionsWrap.insertAdjacentElement('beforeend', li);
            }
        } else {
            const li = document.createElement('li');
            li.textContent = 'No results found';
            this.optionsWrap.insertAdjacentElement('beforeend', li);
        }
    }

    events() {
        // Input focus
        //   this.input.addEventListener('focus', this.open.bind(this));
        this.input.addEventListener('focus', this.handleFocus.bind(this));

        // Input change
        this.input.addEventListener('input', this.handleInputChange.bind(this));

        // Option click
        this.optionsWrap.addEventListener(
            'click',
            this.handleOptionClick.bind(this)
        );

        // Window click
        window.addEventListener('click', this.handleWindowClick.bind(this));

        // Form submit
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    handleFocus() {
        this.bsearch.classList.add('bsearch--focus');
    }

    open() {
        this.isOpened = true;
        this.bsearch.classList.add('bsearch--open');
    }

    close() {
        this.isOpened = false;
        this.bsearch.classList.remove('bsearch--open');
        this.bsearch.classList.remove('bsearch--focus');
        this.input.value = '';
        this.setOptions();
        this.renderOptions();
    }

    handleInputChange(e) {
        this.setOptions();
        this.renderOptions();

        if (e.target.value) this.open();
        else this.close();
    }

    handleOptionClick(e) {
        const li = e.target.closest('li');
        if (!li) return;
        const value = li.dataset.value;
        const label = li.textContent;
        if (!value || !label) return;
        this.currentValue = value;
        this.currentLabel = label;
        this.select.value = value;
        this.select.dispatchEvent(new Event('change'));
        this.renderPreview();
        this.close();
    }

    handleWindowClick(e) {
        if (!e.target.closest('.bsearch')) {
            this.close();
        }
    }

    handleSubmit(e) {
        if (!this.select.value) e.preventDefault();
    }
}

export default new BarristersSearch();
